import { TableCell } from "@mui/material";
import TableHeader from "@crema/core/AppTable/TableHeader";

const TableHeading = () => {
  return (
    <TableHeader>
      <TableCell align="left">S.No</TableCell> 
      <TableCell align="left">Device IP</TableCell> 
      <TableCell align="left">NP Name</TableCell> 
      <TableCell align="left">Pin Code</TableCell> 
      <TableCell align="left">Latitude</TableCell>
      <TableCell align="left">Longitude</TableCell> 
      <TableCell align="left">Host Name</TableCell> 
      <TableCell align="left">Service VLAN ID</TableCell> 
      <TableCell align="left">NAS Port ID</TableCell>
      <TableCell align="left">Voltage</TableCell>
      <TableCell align="left">Switch Connectivity</TableCell> 
      <TableCell align="left">Switch Port No</TableCell>
      <TableCell align="left">Switch Port Connectivity</TableCell>
      <TableCell align="left">Media Converter</TableCell>
      <TableCell align="left">Location</TableCell> 
      <TableCell align="left">Distance from CO</TableCell>
      <TableCell align="left">Power Backup</TableCell> 
      <TableCell align="left">Backup Ownership</TableCell>
      <TableCell align="left">Distance from Link</TableCell>
      <TableCell align="left">Status</TableCell> 
      <TableCell align="right">Action</TableCell>
    </TableHeader>
  );
};

export default TableHeading;
